// extracted by mini-css-extract-plugin
module.exports = {"totals":"CheckoutPage-module--totals--17DB7","submit":"CheckoutPage-module--submit--QmqnH"};